export function isEmpty(str: string = ""): boolean {
  if (!str) {
    return true;
  }
  // 过滤全为空格和全为换行符的情况
  return str?.trim() === "";
}
